<template>
  <section class="testimonials">
    <div class="container">
      <h2 class="section-heading">Testimonials</h2>
      <VueSlickCarousel
        :dots="true"
        :autoplay="true"
        :autoplaySpeed="5000"
        :speed="500"
        :edgeFriction="0"
        class="desktop"
      >
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Carlous Oliviva</h3>
              <p class="country">Portugal</p>
            </div>
            <div class="content">
              Malik is an amazing web developer, he had updated our company
              website according to new design. He understands problem and
              provide quick solutions. Totally recommended.
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Nathnaz</h3>
              <p class="country">Canada</p>
            </div>
            <div class="content">
              Would recommend to anyone looking for help with Vue projects.
              Knows what he's doing, fast delivery and great communication. Will
              return again as a future customer!
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Nathnaz</h3>
              <p class="country">Canada</p>
            </div>
            <div class="content">
              Would recommend to anyone looking for help with Vue projects.
              Knows what he's doing, fast delivery and great communication. Will
              return again as a future customer!
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Clairedoggies</h3>
              <p class="country">United Kingdom</p>
            </div>
            <div class="content">
              Excellent communication, excellent website designer, I am very
              happy and i will work with this seller again on future projects,
              very hard worker, very polite and very talented, he knows his
              stuff! highly recommend you will not be dissapointed
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Clairedoggies</h3>
              <p class="country">United Kingdom</p>
            </div>
            <div class="content">
              Excellent communication, excellent website designer, I am very
              happy and i will work with this seller again on future projects,
              very hard worker, very polite and very talented, he knows his
              stuff! highly recommend you will not be dissapointed
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
          <div class="testimonial-container">
            <div class="client-info">
              <h3>David</h3>
              <p class="country">USA</p>
            </div>
            <div class="content">
              Malik is an amazing developer. He provided reliable solution with in limited time. He knows what he is doing, give suggestions and understands problem.
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
      <VueSlickCarousel :dots="true" :auto="true" :speed="500" class="mobile">
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Carlous Oliviva</h3>
              <p class="country">Portugal</p>
            </div>
            <div class="content">
              Malik is an amazing web developer, he had updated our company
              website according to new design. He understands problem and
              provide quick solutions. Totally recommended.
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Nathnaz</h3>
              <p class="country">Canada</p>
            </div>
            <div class="content">
              Would recommend to anyone looking for help with Vue projects.
              Knows what he's doing, fast delivery and great communication. Will
              return again as a future customer!
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>Clairedoggies</h3>
              <p class="country">United Kingdom</p>
            </div>
            <div class="content">
              Excellent communication, excellent website designer, I am very
              happy and i will work with this seller again on future projects,
              very hard worker, very polite and very talented, he knows his
              stuff! highly recommend you will not be dissapointed
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
        <div class="grid-container">
          <div class="testimonial-container">
            <div class="client-info">
              <h3>David</h3>
              <p class="country">USA</p>
            </div>
            <div class="content">
              Malik is an amazing developer. He provided reliable solution with in limited time. He knows what he is doing, give suggestions and understands problem.
            </div>

            <div class="stars">
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </div>
          </div>
        </div>
      </VueSlickCarousel>
    </div>
  </section>
</template>

<script>
  import VueSlickCarousel from "vue-slick-carousel";
  import "vue-slick-carousel/dist/vue-slick-carousel.css";
  // optional style for arrows & dots
  import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

  export default {
    name: "MyComponent",
    components: { VueSlickCarousel },
  };
</script>

<style scoped>
  .testimonials {
    padding-top: 0px;
  }
  .carosuel1 {
    display: none;
  }

  .grid-container {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
  }
  .testimonial-container {
    background: #f5f5f5;
    padding: 30px 45px;
    border-radius: 10px;
  }
  .client-info {
    margin-bottom: 20px;
  }
  .testimonial-container .client-info h3 {
    color: var(--color-secondary);
    font-size: 1.2em;
    margin-bottom: 5px;
  }
  .client-info .country {
    color: var(--color-primary);
    font-size: 0.9em;
  }

  .stars {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 30px;
  }
  .stars i {
    color: #ffcd3c;
    font-size: 1.2em;
  }

  .mobile {
    display: none;
  }

  @media only screen and (max-width: 767px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
    .grid-container {
      display: grid !important;
      grid-template-columns: repeat(1, 1fr);
      gap: 50px;
    }
  }
</style>
